import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from './Services/authentication.service';
import { User } from './models/user.model';
import { CookieService } from 'ngx-cookie-service';
import { StubsService } from './Services/stubs.service';
import { Instance } from './models/instance.model';
import { Router } from '@angular/router';
import { instanceExpiredDate } from './common/constants/defines';
import { environment } from '../environments/environment';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Automated Stubs Tool';
  private selectedInstance: Instance;
  public allInstances: any[] = [];
  public selectedCookie: string | null = null;
  public currentUser: any = null;
  public settingsSelected: any;
  constructor(
    private cookieService: CookieService,
    public authService: AuthenticationService,
    private _stubsService: StubsService,
    private router: Router) {
  }

  ngOnInit(): void {

    console.log("ENV:", (environment.ssoMode)? "Production" : "Local");

    if (this.cookieService.get('instance') && environment.ssoMode) {
      this.selectedCookie = this.cookieService.get('instance');
    } else if(!environment.ssoMode) {
      this.cookieService.set("instances","de-web");
      this.selectedCookie = "de-web";
    }

    this.authService.instancesIsChanged.asObservable().subscribe((instances) => {

      if (Array.isArray(instances)) {

        this.currentUser = this.authService.currentUser;

        this.allInstances = this.authService.currentUser.instances;

        this.selectedInstance = this.authService.currentUser.instances.filter((instance) => instance.cookieName === this.selectedCookie)[0];

        this.changeInstance(this.selectedInstance);
      }
    });
  }

  public setSettingsSelected(flag) {
    this.settingsSelected = flag;
  }

  changeInstance(instance?: Instance, reload?: boolean) {
    this.settingsSelected = false;
    if (document.cookie.indexOf('instance=') === -1) {
      this.cookieService.set('instance', instance.cookieName, instanceExpiredDate);
      this.selectedInstance = instance;
    } else {
      this.cookieService.delete('instance');
      this.cookieService.set('instance', instance.cookieName, instanceExpiredDate);
      this.selectedInstance = instance;
    }

    this.authService.currentUser.selectedInstance = instance;

    if (reload) {
      window.location.reload();
    }
  }

  navigateToAutomation() {
    this.router.navigate(['automation/tdrs-creation']);
  }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts